_getUserContactDataThunk